import React from 'react'
import { CartItemContainer, ItemDetailsContainer, NameSpanner, QuantitySpanner, ImageHolder } from "./cart-item.styles";

function CartItem({ item: { primaryImage, pricePoint, productname, quantity } }) {
    return (
        <CartItemContainer>
            <ImageHolder src={'https://craftbechoimages.fra1.cdn.digitaloceanspaces.com/productimages/'+primaryImage }  alt={productname} />
            <ItemDetailsContainer>
                <NameSpanner>{productname}</NameSpanner>
                <QuantitySpanner>{quantity}* ₹{pricePoint[0].price}</QuantitySpanner>
            </ItemDetailsContainer>
        </CartItemContainer>
    )
}

export default CartItem
